import { createComponent } from '@carvana/merch-components';
import flattenWhiteSpace from '~/utilities/flattenWhiteSpace';

export const Container = createComponent('div', {
  className: flattenWhiteSpace(`
    bg-white
    border
    border-grey-2
    cursor-pointer
    flex
    flex-row
    gap-[10px]
    h-[52px]
    hover:border-blue-4
    outline-none
    relative
    rounded
    text-grey-5
    text-sm
    w-full
  `)
});

export const Dropdown = createComponent('ul', {
  className: flattenWhiteSpace(`
    absolute
    bg-white
    border-grey-2
    border-t-[1px]
    left-0
    list-none
    outline-none
    p-0
    shadow-[0px_6px_13px_0px_rgba(24,_53,_88,_0.10)]
    text-grey-5
    top-full
    w-full
    z-10
  `)
});

export const Input = createComponent('input', {
  className: flattenWhiteSpace(`
    border-none
    cursor-pointer
    disabled:bg-grey-1
    disabled:cursor-not-allowed
    outline-none
    overflow-hidden
    py-16
    text-blue-6
    w-full
    z-20
  `)
});

export const Label = createComponent('label', {
  className: flattenWhiteSpace(`
    absolute
    cursor-pointer
    self-center
    m-auto
    left-16
    text-sm
    text-grey-5
    z-30
  `)
});
